module.exports = __webpack_public_path__ + "static/media/weatherWhite.b8366b15.svg";